<div class="payment-page">
  @if (loading()) {
    <div class="empty">Zahlungsstatus wird geladen.</div>
  } @else if (payment(); as item) {
    <section class="payment-hero">
      <div>
        <span class="kicker">DriveMe Academy</span>
        <h1>Schulung freischalten</h1>
        <p>Schließe die Zahlung ab, bevor du auf deine Fahrerschulungen zugreifen kannst.</p>
      </div>
      <span class="payment-secure-badge">Sichere Zahlung über Stripe</span>
    </section>

    @if (cancelled()) {
      <div class="inline-warning">Die Zahlung wurde abgebrochen. Du kannst sie jederzeit erneut starten.</div>
    }
    @if (error()) {
      <div class="inline-warning danger">{{ error() }}</div>
    }
    @if (confirming()) {
      <div class="info-message">Zahlung erfolgreich zurückgekehrt. Die Bestätigung wird noch verarbeitet …</div>
    }

    <section class="payment-layout">
      <div class="panel payment-card">
        <span class="kicker">Teilnahmegebühr</span>
        <h2>Fahrerschulung</h2>
        <strong class="payment-amount">{{ item.amountCents / 100 | number:'1.2-2' }} {{ item.currency }}</strong>
        <p class="text-app-muted">Wähle zwischen einer einmaligen Freischaltung für 12 Monate oder einem jährlich verlängernden Abo.</p>
        @if (item.paid) {
          <div class="info-message">Dein Zugang ist bis {{ item.validUntil | date:'dd.MM.yyyy' }} freigeschaltet.</div>
          @if (item.paymentType === 'YEARLY_SUBSCRIPTION' && item.cancelAtPeriodEnd) {
            <div class="inline-warning">Dein Jahresabo ist gekündigt und läuft bis zum Ende der aktuellen Laufzeit.</div>
          }
          <a class="primary-button as-link" routerLink="/learning">Zum Lernbereich</a>
          @if (item.paymentType === 'YEARLY_SUBSCRIPTION' && !item.cancelAtPeriodEnd) {
            <button class="ghost-button" type="button" [disabled]="cancelling()" (click)="openBillingPortal()">
              {{ cancelling() ? 'Stripe-Kundenportal wird geöffnet …' : 'Abo verwalten oder kündigen' }}
            </button>
          }
        } @else {
          <div class="payment-options">
            <label class="payment-option">
              <input type="radio" name="paymentType" [checked]="selectedType() === 'ONE_TIME'" (change)="selectedType.set('ONE_TIME')">
              <span><strong>Einmalzahlung</strong><small>250,00 € für 12 Monate</small></span>
            </label>
            <label class="payment-option">
              <input type="radio" name="paymentType" [checked]="selectedType() === 'YEARLY_SUBSCRIPTION'" (change)="selectedType.set('YEARLY_SUBSCRIPTION')">
              <span><strong>Jahresabo</strong><small>250,00 € pro Jahr, automatisch verlängerbar</small></span>
            </label>
          </div>
          <button class="primary-button" type="button" [disabled]="submitting()" (click)="startPayment()">
            {{ submitting() ? 'Weiterleitung zu Stripe …' : 'Sicher bezahlen' }}
          </button>
          <small class="payment-note">Du wirst zur sicheren Stripe-Zahlungsseite weitergeleitet. Kartendaten werden nicht in DriveMe gespeichert.</small>
        }
      </div>

      <aside class="panel payment-benefits">
        <h2>Danach kannst du</h2>
        <ul>
          <li>alle zugewiesenen Module öffnen</li>
          <li>Lektionen und Quizfragen bearbeiten</li>
          <li>deinen Lernfortschritt verfolgen</li>
          <li>deine Teilnahmebestätigungen einsehen</li>
        </ul>
        <button class="ghost-button" type="button" [disabled]="loading()" (click)="loadStatus()">Zahlungsstatus aktualisieren</button>
      </aside>
    </section>
  } @else {
    <div class="empty">Zahlungsstatus ist nicht verfügbar.</div>
  }
</div>
